module.exports = __webpack_public_path__ + "static/media/045.a787534a.wav";


/*****************
 ** WEBPACK FOOTER
 ** ./src/sound/045.wav
 ** module id = 177
 ** module chunks = 0
 **/